import React from 'react';
import V2Nav from '../homepage-v2/V2Nav';
import AuthMarketingPanel from './AuthMarketingPanel';
import '../homepage-v2/homepageV2.css';
import './authVisual.css';

export default function AuthSplitLayout({
  children,
  wide = false,
  centerContent = false,
  showDemoVideo = false,
}) {
  return (
    <div className="auth-stage">
      <V2Nav />
      <div className="auth-stage-body">
        <div className={`auth-stage-form-wrap${wide ? ' is-wide' : ''}${centerContent ? ' is-centered' : ''}`}>
          <div className="auth-stage-card">{children}</div>
        </div>
        <AuthMarketingPanel showDemoVideo={showDemoVideo} />
      </div>
    </div>
  );
}

export const authInputClass =
  'w-full px-4 py-3 border border-gray-200 rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all';

export const authSelectClass =
  'w-full px-4 py-3 border border-gray-200 rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all';

export const authPrimaryButtonClass =
  'auth-submit disabled:cursor-not-allowed';
